module.exports = "<div class=\"title\">Совпадения в ключевых словах:</div>\n<ul class=\"keyword-list parametric-list\" data-bind=\"foreach: items.slice(0, 8)\">\n\t<li data-bind=\"click: $parent.handleClick, css: 'type-' + type\">\n\t\t<a>\n\t\t\t<span data-bind=\"text: title\"></span>\n\t\t\t<span class=\"item-type\" data-bind=\"text: typeName, visible: type != 'keyword'\"></span>\n\t\t\t<!--<span data-bind=\"text: count\"></span>-->\n\t\t</a>\n\t</li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/quicksearch/templates/keywords.html
// module id = xlbI
// module chunks = 3 4 5 6